import React from 'react'
import { Row, Col, Label } from 'reactstrap'
import { Button } from '@/components/button'
import { openTwoFactorDialog } from '@/utils/twoFactorHelper'

const handleToggle = (props) => () => {
  if (props.isTwoFactorRequired || props.isTwoFactorRequiredByPolicy) {
    openTwoFactorDialog(() => props.toggleTwoFactorAuthentication())
  } else {
    props.toggleTwoFactorAuthentication()
  }
}
const ToggleTwoFactor = (props) => {
  const getText = () => {
    if (props.isTwoFactorRequiredByPolicy) { return 'Security.TwoFactorIsRequiredByPolicy' }
    if (props.isTwoFactorRequired) { return 'Security.TwoFactorIsEnabled' }
    return 'Security.TwoFactorIsDisabled'
  }
  const { localize } = props
  const text = getText()
  const isRequired = props.isTwoFactorRequired || props.isTwoFactorRequiredByPolicy
  return (
    <React.Fragment>
      <Row>
        <Col>
          <Label>{localize(text)}</Label>
        </Col>
      </Row>
      <Row className='mt-3'>
        <Col sm='6'>
          <Button
            color='primary'
            confirmTitle={props.isTwoFactorRequired ? 'Common.Confirmation' : ''}
            confirmText={props.isTwoFactorRequired ? 'Security.DisableConfirmation' : ''}
            onClick={handleToggle(props)}
            disabled={props.isTwoFactorRequiredByPolicy}>{localize(isRequired ? 'Security.DisableTwoFactor' : 'Security.EnableTwoFactor')}</Button>
        </Col>
        {isRequired && <Col sm='6'>
          <Button
            color='primary'
            onClick={props.testCode}>{localize('Security.TestCode')}</Button>
        </Col>}
      </Row>
    </React.Fragment>
  )
}

export {
  ToggleTwoFactor
}



// WEBPACK FOOTER //
// ./src/dialogs/twoFactorSetup/toggleTwoFactor.js